import { DashExceptions } from './consts.js';
import { WaitFetch, pkmJSON, convertPkmNameToURI, AddPkmTypeBlockPair, ColorPkmTypeBlocks } from './helper.js';

var stickyOffset = -1;

$(window).on("load", async function () {
	await WaitFetch();

	await createPkmList();

	sortPkmList("speciesIdx", true);

	$(".firstSort").append(createSortArrow(false));

	$(window).on('scroll', function () {
		if (window.scrollY > stickyOffset && stickyOffset > 0)
			$("#stickyHeader").addClass("sticky");
		else
			$("#stickyHeader").removeClass("sticky");
	});
	
	$(".sortable").on("click", function () {
		$(".sortArrowDown").not($(this).find(".sortArrowDown")).remove();
		$(".sortArrowUp").not($(this).find(".sortArrowUp")).remove();

		let svgArrowDown = createSortArrow(true);
		let svgArrowUp = createSortArrow(false);
		let sortClass = $(this).find("h5")[0].className;

		// Sort Ascending
		if ($(this).find(".sortArrowDown").length) {
			$(".sortArrowDown").remove();
			$(this).append(svgArrowUp);
			sortPkmList(sortClass, true);
		}
		// Sort Descending
		else if ($(this).find(".sortArrowUp").length) {
			$(".sortArrowUp").remove();
			$(this).append(svgArrowDown);
			sortPkmList(sortClass, false);
		}
		// Selectively Sort Asc/Desc
		else {
			if (sortClass == "speciesIdx" || sortClass == "pkmName") {
				$(this).append(svgArrowUp);
				sortPkmList(sortClass, true);
			}
			else {
				$(this).append(svgArrowDown);
				sortPkmList(sortClass, false);
			}
		}
	});
});

function createSortArrow(down: boolean) {
	let svgArrowDown = `<div class="sortArrowDown"><svg fill="#eee" height="16px" width="16px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-33 -33 396.00 396.00" xml:space="preserve" stroke="#ffffff" stroke-width="0.00330002" transform="rotate(0)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="2.640016"></g><g id="SVGRepo_iconCarrier"> <path id="XMLID_23_" d="M329.155,100.036c-2.108-6.011-7.784-10.035-14.154-10.035h-300c-6.371,0-12.046,4.024-14.154,10.035 c-2.109,6.011-0.19,12.699,4.784,16.678l150.004,120c2.739,2.191,6.055,3.287,9.37,3.287c3.316,0,6.631-1.096,9.371-3.287 l149.996-120C329.346,112.734,331.264,106.047,329.155,100.036z"></path></g></svg></div>`;
	let svgArrowUp = `<div class="sortArrowUp"><svg fill="#eee" height="16px" width="16px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-33 -33 396.00 396.00" xml:space="preserve" stroke="#ffffff" stroke-width="0.00330002" transform="rotate(0)matrix(1, 0, 0, -1, 0, 0)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="2.640016"></g><g id="SVGRepo_iconCarrier"> <path id="XMLID_23_" d="M329.155,100.036c-2.108-6.011-7.784-10.035-14.154-10.035h-300c-6.371,0-12.046,4.024-14.154,10.035 c-2.109,6.011-0.19,12.699,4.784,16.678l150.004,120c2.739,2.191,6.055,3.287,9.37,3.287c3.316,0,6.631-1.096,9.371-3.287 l149.996-120C329.346,112.734,331.264,106.047,329.155,100.036z"></path> </g></svg></div>`;

	return down ? svgArrowDown : svgArrowUp;
}

async function createPkmList() {
	let toAppend = [];

	toAppend.push(`<div id="stickyHeader" class="row">`);
	toAppend.push(`<div class="sortable firstSort"><h5 class="speciesIdx">#</h5></div>`);
	toAppend.push(`<div class="sortable"><h5 class="pkmName">Pokemon</h5></div>`);
	toAppend.push(`<h5>Type</h5>`);
	toAppend.push(`<h5>Abilities</h5>`);
	toAppend.push(`<div class="statDiv sortable hpColor"><h5 class="hp">HP</h5></div>`);
	toAppend.push(`<div class="statDiv sortable atkColor"><h5 class="atk">Atk</h5></div>`);
	toAppend.push(`<div class="statDiv sortable defColor"><h5 class="def">Def</h5></div>`);
	toAppend.push(`<div class="statDiv sortable spaColor"><h5 class="spa">SpA</h5></div>`);
	toAppend.push(`<div class="statDiv sortable spdColor"><h5 class="spd">SpD</h5></div>`);
	toAppend.push(`<div class="statDiv sortable speColor"><h5 class="spe">Spe</h5></div>`);
	toAppend.push(`<div class="statDiv sortable"><h5 class="bst">BST</h5></div>`);
	toAppend.push(`</div>`);

	$(`#dexList`).append(toAppend.join(''));
	
	stickyOffset = $("#stickyHeader").offset()!.top;

	Object.entries(pkmJSON!).forEach(([pkmName, pkmEntry]) => {
		toAppend = [];

		// Species Idx
		let form = "";
		if (pkmName.includes("-") && !DashExceptions.includes(pkmName)) {
			form = pkmName.slice(pkmName.indexOf("-"));
		}

		let uri = convertPkmNameToURI(pkmName);
		if (form != "")
			uri = uri.slice(0, pkmName.indexOf(form));

		if (pkmEntry.SpeciesIdx == 710 || pkmEntry.SpeciesIdx == 711)
			form = "";

		form = form.toLowerCase();

		toAppend.push(`<a href="/dex/${uri}" class="pkmLink"><div class="row">`);
		toAppend.push(`<p class="speciesIdx">${pkmEntry.SpeciesIdx}</p>`);

		// Icon + Name
		toAppend.push(`<div class="pkmIconWrapper"><img src="/images/pkm/icons/png/${pkmEntry.SpeciesIdx}${form}.png"><p class="pkmName">${pkmName}</p></div>`);

		// Types
		toAppend.push(`<div class="flex">`);
		toAppend.push(AddPkmTypeBlockPair(pkmName));
		toAppend.push(`</div>`);

		// Abilities
		toAppend.push(`<div class="flex">`);

		toAppend.push(`<div class="flexCol"><ol><li>${pkmEntry.Ability1}</li>`);

		if (pkmEntry.Ability2 != "")
			toAppend.push(`<li>${pkmEntry.Ability2}</li>`);

		if (pkmEntry.AbilityH != "")
			toAppend.push(`<li class="hiddenAbility">${pkmEntry.AbilityH}</li>`);

		toAppend.push(`</ol></div></div>`);

		// Stats
		toAppend.push(`<div class="statDiv hpColor"><p class="hp">${pkmEntry.BaseStats.HP}</p></div>`);
		toAppend.push(`<div class="statDiv atkColor"><p class="atk">${pkmEntry.BaseStats.Atk}</p></div>`);
		toAppend.push(`<div class="statDiv defColor"><p class="def">${pkmEntry.BaseStats.Def}</p></div>`);
		toAppend.push(`<div class="statDiv spaColor"><p class="spa">${pkmEntry.BaseStats.SpA}</p></div>`);
		toAppend.push(`<div class="statDiv spdColor"><p class="spd">${pkmEntry.BaseStats.SpD}</p></div>`);
		toAppend.push(`<div class="statDiv speColor"><p class="spe">${pkmEntry.BaseStats.Spe}</p></div>`);
		toAppend.push(`<div class="statDiv"><p class="bst">${pkmEntry.BaseStats.HP + pkmEntry.BaseStats.Atk + pkmEntry.BaseStats.Def + pkmEntry.BaseStats.SpA + pkmEntry.BaseStats.SpD + pkmEntry.BaseStats.Spe}</p></div>`);
		toAppend.push(`</div>`);

		$(`#dexList`).append(toAppend.join(''));
	});

	ColorPkmTypeBlocks();
}

function sortPkmList(sortClass: string, ascending: boolean) {
	let pkmRows = $(".pkmLink");

	// Variation of Insertion Sort
	let i = 1;
	while (i < pkmRows.length) {
		let j = i;
		let row = pkmRows[i];

		let sortValue: string | number = $(pkmRows[i]).find(`.${sortClass}`).text();
		let prevSortValue: string | number = $(pkmRows[j - 1]).find(`.${sortClass}`).text();

		if (sortClass != "pkmName") {
			sortValue = parseInt(sortValue);
			prevSortValue = parseInt(prevSortValue);
		}

		while (j > 0 && (ascending ? prevSortValue > sortValue : prevSortValue < sortValue)) {
			pkmRows[j] = pkmRows[j - 1];
			j -= 1;
			prevSortValue = $(pkmRows[j - 1]).find(`.${sortClass}`).text();

			if (sortClass != "pkmName") {
				prevSortValue = parseInt(prevSortValue);
			}
		}

		$(pkmRows[j]).before(row);
		pkmRows[j] = row;

		i += 1;
	}
}